import { render } from "./CategoryPicker.vue?vue&type=template&id=ae97a754&scoped=true&ts=true"
import script from "./CategoryPicker.vue?vue&type=script&lang=ts"
export * from "./CategoryPicker.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae97a754"]])

export default __exports__